module.exports = __webpack_public_path__ + "static/media/drumheller-15.8c17dd05.jpg";